// A slide is a top-level <section> (matches EditableVisual; the scheduler counts `<section\b` in Node).
export const countSlides = (html: string): number =>
  new DOMParser().parseFromString(html, "text/html").querySelectorAll("body > section").length;
